import React from 'react';
import { useSetRecoilState, useRecoilValue } from 'recoil';
import { useMutation } from '@apollo/client';

import { loadingState, authenticationState } from 'state/atoms';
import { ButtonPrimary } from 'components';
import { CREATE_ADDRESS } from 'connectors/mutations/account';
import { ADDRESS_SHIPPING_FIELDS } from 'pages/CheckoutShipping/constants';
import { useNotifyError } from 'utils/hooks';

const AddToFavoritesButton = ({
  formController,
  afterAddAddress,
  ...buttonProps
}) => {
  const { endCustomerAccountId } = useRecoilValue(authenticationState);
  const setLoading = useSetRecoilState(loadingState);

  const notifyError = useNotifyError({
    fallbackMessage: 'Error adding this address to favorites',
  });

  const [createAddress] = useMutation(CREATE_ADDRESS);

  const getMutationVars = (address) => ({
    variables: {
      input: {
        accountId: endCustomerAccountId,
        favorite: true,
        address,
      },
    },
  });

  const handleAddFavorite = () => {
    formController.trigger(ADDRESS_SHIPPING_FIELDS).then((addressIsValid) => {
      if (addressIsValid) {
        setLoading(true);

        // Do not send id field when creating a new address
        const requiredAddressFields = ADDRESS_SHIPPING_FIELDS.filter(
          (field) => field !== 'id'
        );
        const address = formController.getValues(requiredAddressFields);

        createAddress(getMutationVars(address))
          .then(({ data: { createAddress } }) => {
            formController.setValue('id', createAddress[0].addressId);
            afterAddAddress();
          })
          .catch(() => {
            setLoading(false);
            notifyError();
          });
      }
    });
  };

  return (
    <ButtonPrimary onClick={handleAddFavorite} {...buttonProps}>
      ADD TO FAVORITES
    </ButtonPrimary>
  );
};

export { AddToFavoritesButton };
